














import { computed, defineComponent } from "@vue/composition-api";
import Message from "@/components/Message.vue";
import injectStrict from "@/utilities/injectstrict";
import { RoleKey } from "../symbols";
import IButton from "@/interfaces/IButton";
import useNavigateToRole from "@/composables/navigation/useNavigateToRole";

export default defineComponent({
  components: {
    Message,
  },
  setup(_, { root }) {
    const role = injectStrict(RoleKey);
    return {
      primaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("roles.show"),
          variant: "success",
          onClick: async () => {
            await root.$router.back();
            setTimeout(() => {
              useNavigateToRole(root.$router, role.id);
            }, 500);
          },
        };
      }),
      secondaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("common.done"),
          variant: "info",
          onClick: () => {
            root.$router.back();
          },
        };
      }),
    };
  },
});
